'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSuggestions;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getSearchForOption = require('./getSearchForOption');

var _getSearchForOption2 = _interopRequireDefault(_getSearchForOption);

var _getFormattedValue = require('./getFormattedValue');

var _getFormattedValue2 = _interopRequireDefault(_getFormattedValue);

var _locationItemIcon = require('../icons/locationItemIcon');

var _locationItemIcon2 = _interopRequireDefault(_locationItemIcon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function getSuggestions(results, searchValue) {
  return [(0, _getSearchForOption2.default)(searchValue)].concat(results.map(function (place) {
    return (0, _getFormattedValue2.default)(place, true, _react2.default.createElement(_locationItemIcon2.default, null));
  }));
}